import ingresoDetalleService from '../services/ingresoDetalleService';

export const FETCH_DETALLES_REQUEST = 'FETCH_DETALLES_REQUEST';
export const FETCH_DETALLES_SUCCESS = 'FETCH_DETALLES_SUCCESS';
export const FETCH_DETALLES_FAILURE = 'FETCH_DETALLES_FAILURE';

export const CREATE_DETALLE_REQUEST = 'CREATE_DETALLE_REQUEST';
export const CREATE_DETALLE_SUCCESS = 'CREATE_DETALLE_SUCCESS';
export const CREATE_DETALLE_FAILURE = 'CREATE_DETALLE_FAILURE';

export const UPDATE_DETALLE_REQUEST = 'UPDATE_DETALLE_REQUEST';
export const UPDATE_DETALLE_SUCCESS = 'UPDATE_DETALLE_SUCCESS';
export const UPDATE_DETALLE_FAILURE = 'UPDATE_DETALLE_FAILURE';

export const DELETE_DETALLE_REQUEST = 'DELETE_DETALLE_REQUEST';
export const DELETE_DETALLE_SUCCESS = 'DELETE_DETALLE_SUCCESS';
export const DELETE_DETALLE_FAILURE = 'DELETE_DETALLE_FAILURE';

export const fetchDetallesByIngreso = (ingresoId) => async (dispatch) => {
  dispatch({ type: FETCH_DETALLES_REQUEST });
  try {
    const response = await ingresoDetalleService.fetchDetallesByIngreso(ingresoId);
    dispatch({ type: FETCH_DETALLES_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: FETCH_DETALLES_FAILURE, payload: error.message });
  }
};

export const createDetalle = (detalleData) => async (dispatch) => {
  dispatch({ type: CREATE_DETALLE_REQUEST });
  try {
    const response = await ingresoDetalleService.createDetalle(detalleData);
    dispatch({ type: CREATE_DETALLE_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: CREATE_DETALLE_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};

export const updateDetalle = (id, detalleData) => async (dispatch) => {
  dispatch({ type: UPDATE_DETALLE_REQUEST });
  try {
    const response = await ingresoDetalleService.updateDetalle(id, detalleData);
    dispatch({ type: UPDATE_DETALLE_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    dispatch({ type: UPDATE_DETALLE_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};

export const deleteDetalle = (id) => async (dispatch) => {
  dispatch({ type: DELETE_DETALLE_REQUEST });
  try {
    await ingresoDetalleService.deleteDetalle(id);
    dispatch({ type: DELETE_DETALLE_SUCCESS, payload: id });
  } catch (error) {
    dispatch({ type: DELETE_DETALLE_FAILURE, payload: error.message });
    return Promise.reject(error);
  }
};